import React from 'react';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';

import { Text } from 'grommet';
import RevertButton from 'app/components/BookmarkMenu/RevertButton';
import AwaitingSelectionNotification from 'app/components/BookmarkMenu/AwaitingSelectionNotification';
import CancelDeleteBookmarkButton from 'app/components/BookmarkMenu/CancelDeleteBookmarkButton';
import ConfirmDeleteBookmarkButton from 'app/components/BookmarkMenu/ConfirmDeleteBookmarkButton';

const ResponsiveText = styled(Text)`
  font-size: 20px;
  line-height: 28px;
  @media (max-width: 600px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

function DeleteBookmarkMenu({ AppState }) {
  if (!AppState.isUserDeleting) return null;
  if (AppState.bookmarkToDelete.length) {
    return (
      <React.Fragment>
        <CancelDeleteBookmarkButton />
        <ResponsiveText weight="bold" color="accent-1" >
          Delete this bookmark?
        </ResponsiveText>
        <ConfirmDeleteBookmarkButton />
      </React.Fragment>
    );
  }
  if (!AppState.bookmarkToDelete.length) {
    return (
      <React.Fragment>
        <AwaitingSelectionNotification selection ="bookmark to delete"/>
        <RevertButton onClick={() => AppState.setMenuBar('BOOKMARKS_MENU')} />
      </React.Fragment>
    );
  }
}

export default inject('AppState')(observer(DeleteBookmarkMenu));



// WEBPACK FOOTER //
// ./src/app/components/BookmarkMenu/DeleteBookmarkMenu.js